<div class="modal-header">
  <h4 class="modal-title pull-left no-text-transform"> {{'general.multi_date' | translate}}</h4>
  <div class="mt-5">
   <img alt="close" (click)="closeModal()" style="height: 50%;" src="assets/images/icon/svg/round-close.svg"> 
  </div>
</div>

<div class="pop-content">
  @for (product of multipleEventPopUpData; track product.eventId) {
    <div class="options">
      <div class="card-content" style="align-items: center;" (click)="gotoEvent(product.eventId)">
        <div class="product-img-container">
        <img [src]="multipleEventPopUpData[0]?.image" defaultImgPath="assets/images/icon/svg/ct.svg" class="product-img" imageLoader thumbnailSize="S">
        </div>

        <div class="card-details">
          <div class="ticket-label">
          <svg width="102" height="17" viewBox="0 0 102 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M102 16.7949L42.2202 16.7912C36.3219 16.7908 30.6708 14.422 26.5353 10.2165L22.9541 6.57471C18.8503 2.4014 13.2541 0.0367985 7.40488 0.000398636L0.8172 -2.86102e-05H7.26778C7.3135 -2.86102e-05 7.3592 0.000114441 7.40488 0.000398636L67.2985 0.00427628H89.9999C96.6274 0.00427628 102 5.37598 102 12.0034L102 16.7949Z" fill="#D9DBDF"/>
          <text x="65" y="11" text-anchor="middle" font-family="Open Sans, Arial, sans-serif" font-size="8" font-weight="400" letter-spacing="-0.03em" fill="#323232"> {{ 'general.biglietto' | translate }} </text>
          </svg>
          </div>

          <div class="product-title mb-5">{{product.title}}</div>

          <div class="product-location mb-10">
          <i class="ti-location-pin info-icon"></i>
          <span>{{product.location ? product.location : ''}}</span>
          </div>

          @if (product.startDateTime) {
            <div class="datetime-row">
              <div class="date-info">
               <i class="ti-calendar info-icon"></i>
               <span class="text-capitalize">{{ product.startDateTime | localizedDate}}</span>
              </div>
              <div class="time-info">
                <i class="ti-time info-icon"></i>
                <span>{{ product.startDateTime | localizedDate:'HH:mm'}}</span>
              </div>
            </div>
          }
        </div>
    </div>
    </div>
  }

</div>
<div style="height: 15px;"></div>
